import React from "react";
import { Link } from "react-router-dom";
import Text from "../Text/Text";
import { useSelector } from "react-redux";

const PageSideBarMenuLink = ({ item, toggleItem }) => {
    const { id, href, items, label, icon } = item;
    const lang = useSelector(store => store.authReducer.lang);

    return (
        <>
            {href ? (
                <Link
                    id={id}
                    to={href ? href : " "}
                    aria-expanded={!!items ? "true" : null}
                    onClick={() => toggleItem(id)}
                >
                    <i className={icon}></i>
                    <div className="long">
                        <Text lang={lang} value={label} />
                    </div>
                </Link>
            ) : (
                <a
                    id={id}
                    aria-expanded={!!items ? "true" : null}
                    onClick={() => toggleItem(id)}
                    href={null}
                >
                    <i className={icon}></i>
                    <div className="long">
                        <Text lang={lang} value={label} />
                    </div>
                </a>
            )}
        </>
    );
};

export default PageSideBarMenuLink;
